import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface NominatimResponse {
  lat: string;
  lon: string;
  display_name: string;
}

@Injectable({
  providedIn: 'root'
})
export class NominatimService {
  private http: HttpClient = inject(HttpClient);
  private apiUrl = 'https://nominatim.openstreetmap.org/search';

  constructor() {}

  searchCity(query: string): Observable<NominatimResponse[]> {
    const params = {
      q: query,
      format: 'json',
      addressdetails: '1',
      limit: '5'
    };
    return this.http.get<NominatimResponse[]>(this.apiUrl, { params }).pipe(
      map(results => results.map(result => ({
        lat: result.lat,
        lon: result.lon,
        display_name: result.display_name
      })))
    );
  }
}
